import {TopReelFeature} from "./TopReelFeature";
import {FeatureList} from "../../../../GameConfig";
import {gsap} from "gsap";

export class DeadFeature extends TopReelFeature {
    constructor(reelId: number) {
        super(reelId, FeatureList.DEAD);
    }

    public playSmokeOutAnim(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(this.playAnimation("9_smokeOut"));

        return tl;
    }
}